var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRelatoriosGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#86888C;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S\\xE1bana-de-iconos-Copy",
    transform: "translate(-1127.000000, -1210.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_digitalfiles_regular",
    className: "st0",
    d: "M1369,1440c-1-2.9-2.4-5.8-4.7-7.9l-81.7-81c-3.5-3.6-8.6-5.6-13.5-5.6h-51.4 v-18.2c0-15.3,3.3-26.5,9.8-33.2c6.7-7.1,18.2-10.7,33.7-10.7l291.6-0.2c15.7,0,27,3.6,33.7,10.7c6.6,6.7,9.8,18,9.8,33.2v140.4 c0,15.5-3.3,26.8-9.8,33.7c-6.9,7.3-18.2,10.9-33.7,10.9l-182.5,0.2v-65.9C1370.3,1444,1369.9,1441.9,1369,1440z M1280.2,1405.7 v-13.4l42.9,42.3H1310c-6.5,0-15.3-1.2-22-7.8C1282.9,1421.6,1280.2,1414.5,1280.2,1405.7z M1339.6,1636.8h-181.9v-260h91.9v28.9 c0,17.3,5.9,32.5,17.1,43.5c11.1,11.1,26,16.8,43.3,16.8h29.6L1339.6,1636.8L1339.6,1636.8z M1552.8,1543.3 c24.1,0,42.9-6.9,55.6-20.5c12.5-13,18.6-31.6,18.6-55.4V1327c0-23.9-6.1-42.3-18.6-55.3c-12.6-13.4-31.5-20.1-55.6-20.1 l-291.6,0.2c-24.1,0-42.9,6.7-55.6,20c-12.3,12.8-18.6,31.4-18.6,55.2v18.2h-32.5c-14.7,0-27.5,13-27.5,28v267 c0,15,12.6,27.8,27.5,27.8h188.1c14.9,0,27.5-12.8,27.5-27.8v-45.4h241.4c8.6,0,15.3-6.9,15.3-15.7c0-8.6-6.7-15.7-15.3-15.7 h-241.3v-20.1L1552.8,1543.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRelatoriosGray);
export default __webpack_public_path__ + "static/media/ic-relatorios-gray.4ef7e59276d0661a49d73d717fd50e2a.svg";
export { ForwardRef as ReactComponent };